import Vue from 'vue'

const DEFAULT_DELAY_MS = 1000

Vue.directive('autohide-scrollbar', {
  bind (el, binding) {
    const delay = (binding.value && binding.value.delay) || DEFAULT_DELAY_MS
    el.classList.add('autohide-scrollbar')

    let hideTimeout

    const clearHideTimeout = () => {
      if (hideTimeout) {
        clearTimeout(hideTimeout)
        hideTimeout = null
      }
    }

    const hide = () => {
      el.classList.remove('scrollbar-visible')
    }

    const scheduleHide = () => {
      clearHideTimeout()
      hideTimeout = setTimeout(hide, delay)
    }

    const show = () => {
      el.classList.add('scrollbar-visible')
      scheduleHide()
    }

    const onScroll = () => show()
    const onEnter = () => {
      el.classList.add('scrollbar-visible')
      clearHideTimeout()
    }
    const onLeave = () => scheduleHide()

    el.addEventListener('scroll', onScroll, { passive: true })
    el.addEventListener('mouseenter', onEnter)
    el.addEventListener('mouseleave', onLeave)

    el._autohideScrollbar = {
      onScroll,
      onEnter,
      onLeave,
      clearHideTimeout
    }
  },

  unbind (el) {
    const handlers = el._autohideScrollbar
    if (!handlers) {
      return
    }

    handlers.clearHideTimeout()
    el.removeEventListener('scroll', handlers.onScroll)
    el.removeEventListener('mouseenter', handlers.onEnter)
    el.removeEventListener('mouseleave', handlers.onLeave)
    el.classList.remove('autohide-scrollbar', 'scrollbar-visible')
    delete el._autohideScrollbar
  }
})
